// extracted by mini-css-extract-plugin
export default {"base":"sVJue","pageButtons":"olchM","round":"Sx1SG","hidden":"jDwl6","clipper":"UMjTV","carousel":"jgivQ","pageControl":"FufLA","active":"nCSID"};